import { Http } from '@angular/http';
import { AppVersion } from '@ionic-native/app-version';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, LoadingController, Platform, PopoverController, ToastController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { AppConfig } from '../../../app/app.config';
import { AlertFacade } from '../../facades/alert-facade';
import { LoadingFacade } from '../../facades/loading-facade';
import { MetaFacade } from '../../facades/meta-facade';
import { PopoverFacade } from '../../facades/popover-facade';
import { ToastFacade } from '../../facades/toast-facade';
import { IAppFacade } from './app-facade.interface';

export class AppFacade implements IAppFacade {

    private readonly alertFacade: AlertFacade;
    private readonly loadingFacade: LoadingFacade;
    private readonly metaFacade: MetaFacade;
    private readonly toastFacade: ToastFacade;
    private readonly platformService: Platform;
    private readonly popoverFacade: PopoverFacade;
    private readonly appConfig: AppConfig;

    constructor(
        config: AppConfig,
        translateService: TranslateService,
        toastController: ToastController,
        loadingController: LoadingController,
        alertController: AlertController,
        popoverController: PopoverController,
        platformService: Platform,
        appVersion: AppVersion,
        http: Http
    ) {

        this.appConfig = config;
        this.alertFacade = new AlertFacade(this, alertController, translateService);
        this.loadingFacade = new LoadingFacade(this, loadingController, translateService);
        this.metaFacade = new MetaFacade(this, http, appVersion, platformService);
        this.toastFacade = new ToastFacade(this, toastController, translateService);
        this.popoverFacade = new PopoverFacade(this, popoverController);
        this.platformService = platformService;
    }

    get alert(): AlertFacade {
        return this.alertFacade;
    }

    get config(): AppConfig {
        return this.appConfig;
    }

    get loading(): LoadingFacade {
        return this.loadingFacade;
    }

    get meta(): MetaFacade {
        return this.metaFacade;
    }

    get toast(): ToastFacade {
        return this.toastFacade;
    }

    get platform(): Platform {
        return this.platformService;
    }

    get popover(): PopoverFacade {
        return this.popoverFacade;
    }

    getActiveUser(): Observable<any> {
        return of(undefined);
    }

    protected initOnAfterLogin(): void {
        // noop
    }
}



// WEBPACK FOOTER //
// ./src/core/services/app-facade/app-facade.service.ts